module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-9.8108b55f.jpg";